import * as postMessage from './postMessage'

const getMessageData = function (dotId, pageId, event, data) {
  try {
    // Needs to be a JSON
    var dotData = JSON.parse(data)
    return (
      dotData &&
      dotData.hasOwnProperty('dotId') &&
      dotData.dotId === dotId + '' &&
      dotData.hasOwnProperty('pageId') &&
      dotData.pageId === pageId + '' &&
      dotData.hasOwnProperty('event') &&
      dotData.event === event &&
      dotData
    )
  } catch (err) {
    return false
  }
}

const onMessage = function (dotId, pageId, event, cb) {
  postMessage.onMessage(function (data) {
    var dotData = getMessageData(dotId, pageId, event, data)
    if (dotData) {
      return cb(dotData.data)
    }
  })
}

const sendMessage = function (
  dotId,
  pageId,
  event,
  targetOrigin,
  data,
  target
) {
  target = target || window.parent
  if (target) {
    postMessage.sendMessage(
      target,
      targetOrigin || '*',
      JSON.stringify({
        dotId: dotId.toString(),
        pageId: pageId,
        event: event,
        data: data,
      })
    )
  }
}

export { onMessage, sendMessage }
